'use client';

import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { type TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

import { campaignManagerTheme } from '@campaign-manager/theme';

export const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: campaignManagerTheme.color.black,
    boxShadow: theme.shadows[1],
    borderRadius: 24,
    maxWidth: 'unset',
  },
}));
